export default __webpack_public_path__ + "static/media/m.fba2de5c.svg";